export const PICKUP_AND_DROPOFF_FULFILMENT_METHOD = 'PICKUP_AND_DROPOFF';

export interface PickupAndDropoffCoordinateState {
  latitude?: number | null;
  longitude?: number | null;
  pickupLatitude?: number | null;
  pickupLongitude?: number | null;
}

export interface PickupAndDropoffAddressState
  extends PickupAndDropoffCoordinateState {
  customerStreet?: unknown;
  pickupStreet?: unknown;
}

export function isPickupAndDropoffFulfilmentMethod(
  orderFulfilmentMethod: string | null | undefined,
): boolean {
  return orderFulfilmentMethod === PICKUP_AND_DROPOFF_FULFILMENT_METHOD;
}

export function hasPickupAndDropoffStreetValues(
  addressState: Pick<
    PickupAndDropoffAddressState,
    'customerStreet' | 'pickupStreet'
  >,
): boolean {
  return (
    hasNonBlankText(addressState.pickupStreet) &&
    hasNonBlankText(addressState.customerStreet)
  );
}

export function hasCompletePickupAndDropoffCoordinates(
  coordinateState: PickupAndDropoffCoordinateState | null | undefined,
): boolean {
  return (
    hasCoordinatePair(
      coordinateState?.pickupLatitude,
      coordinateState?.pickupLongitude,
    ) &&
    hasCoordinatePair(coordinateState?.latitude, coordinateState?.longitude)
  );
}

export function hasCompletePickupAndDropoffAddressState(
  addressState: PickupAndDropoffAddressState | null | undefined,
): boolean {
  if (!addressState) {
    return false;
  }
  return (
    hasPickupAndDropoffStreetValues(addressState) &&
    hasCompletePickupAndDropoffCoordinates(addressState)
  );
}

export function shouldDispatchAssociatedZoneLookup(
  orderUpdateType: string | null | undefined,
  orderFulfilmentMethod: string | null | undefined,
  coordinateState: PickupAndDropoffCoordinateState | null | undefined,
): boolean {
  if (!isAssociatedZoneLookupTrigger(orderUpdateType)) {
    return false;
  }
  if (!isPickupAndDropoffFulfilmentMethod(orderFulfilmentMethod)) {
    return true;
  }
  return hasCompletePickupAndDropoffCoordinates(coordinateState);
}

function isAssociatedZoneLookupTrigger(
  orderUpdateType: string | null | undefined,
): boolean {
  return (
    orderUpdateType === 'UpdateZipCode' ||
    orderUpdateType === 'UpdateZoneLocation'
  );
}

function hasCoordinatePair(
  latitude: number | null | undefined,
  longitude: number | null | undefined,
): boolean {
  return isFiniteCoordinate(latitude) && isFiniteCoordinate(longitude);
}

function isFiniteCoordinate(value: number | null | undefined): boolean {
  return typeof value === 'number' && Number.isFinite(value);
}

function hasNonBlankText(value: unknown): boolean {
  return typeof value === 'string' && value.trim().length > 0;
}
